export function sum(...sums) {
  return sums.reduce((accSum, sum) => {
    return sum.reduce((acc, money) => {
      const i = acc.findIndex(({ currency }) => money.currency === currency);
      if (i !== -1) {
        acc[i].value += money.value;
      } else {
        acc.push({ ...money });
      }
      return acc;
    }, accSum);
  }, []);
}

export function subtract(a, b) {
  return sum(a, invert(b));
}

export function isZero(sum) {
  return !sum.find(({ value }) => value !== 0);
}

export function isEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return isZero(subtract(a, b));
}

const invertMoney = ({ value, currency }) => ({ currency, value: -value });

export function invert(sum) {
  return sum.map(invertMoney);
}

export function sort(sum) {
  return sum.sort((a, b) =>
    a.currency === b.currency
      ? 0
      : a.currency === "PLN"
      ? -1
      : b.currency === "PLN"
      ? 1
      : a.currency.localeCompare(b.currency)
  );
}



// WEBPACK FOOTER //
// ./src/lib/utils/MoneySum.js